/**
 * @learnzapp/core/articles — the article engagement toolkit: metered weekly
 * unlock access decisions, per-domain sequential reading paths, and
 * weakness-driven reading recommendations. Pure functions over already-fetched
 * plain objects; apps own all persistence and UI.
 */
export * from './accessMeter';
export * from './interstitial';
export * from './meterMessages';
export * from './readingPath';
export * from './recommendations';
// The content-agnostic metered-unlock primitives live in ../metering; re-export
// them here so article surfaces keep one import site (@learnzapp/core/articles).
export * from '../metering';
